import { VariantType2 } from "@app/enums/variant-type-2";

export enum BlindType {
    Blind = 'BLIND',
    LateRegistrationPeriod = 'LateRegistrationPeriod',
    ReBuyPeriod = 'ReBuyPeriod',
    AddonBreakOn = 'AddonBreakOn',
    Break = 'Break',
}
export interface Blind {
    id: number;
    type: BlindType;
    level: number;
    startTime: number;
    duration: number;

    period: number;
    blind: number;
    periodStartMinutes: number;
    ante?: number;

    variant?: VariantType2; // Mix Tournament
}